import React from 'react';
import { testimonials } from '../mockData';
import { Play } from 'lucide-react';
import VideoTestimonialsCarousel from '../components/VideoTestimonialsCarousel';

const Testimonials = () => {
  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="testimonials-hero">
        <div className="content-wrapper text-center-content">
          <h1 className="page-title">Student Success Stories</h1>
          <p className="page-subtitle">
            Hear from our graduates who have transformed their careers
          </p>
        </div>
      </section>

      {/* YouTube Section */}
      <section className="section-container">
        <div className="content-wrapper">
          <h2 className="section-title">Video Testimonials</h2>
          <p className="section-description">
            Watch real stories from our students and see how our training has helped them succeed
          </p>
          
          <div className="video-grid">
            {/* YouTube Channel Embed */}
            <div className="video-card featured">
              <div className="video-embed">
                <iframe
                  width="100%"
                  height="400"
                  src="https://www.youtube.com/embed/YtmZcKHQEoY"
                  title="Student Success Stories - Hair Extensions Training Academy"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="video-info">
                <h3 className="video-title">Visit Our YouTube Channel</h3>
                <p className="video-description">@needahairmakeover</p>
                <a
                  href="https://youtube.com/@needahairmakeover"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary"
                >
                  Subscribe to Our Channel
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Promo Banner — Turn Your Passion Into A Profession */}
      <section className="section-container" data-testid="testimonials-passion-banner-section">
        <div className="content-wrapper">
          <div className="testimonials-passion-banner">
            <img
              src="https://customer-assets.emergentagent.com/job_e0838653-edb4-4055-aeea-30513770ad02/artifacts/3x938hog_WhatsApp%20Image%202026-06-30%20at%2017.46.11.jpeg"
              alt="Turn Your Passion Into A Profession — Hair Extensions Training Academy. Award winning training, 1, 2, 3 or 5 day courses. Enrol today at hairextensionstraining.academy."
              className="testimonials-passion-banner-image"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* TikTok Section */}
      <section className="section-container section-alt">
        <div className="content-wrapper">
          <h2 className="section-title">Follow Us on TikTok</h2>
          <p className="section-description">
            See transformations, tips, and behind-the-scenes content
          </p>
          
          <div className="tiktok-section">
            <a
              href="https://www.tiktok.com/@needahairmakeover"
              target="_blank"
              rel="noopener noreferrer"
              className="tiktok-link"
            >
              <div className="tiktok-card">
                <Play size={48} className="tiktok-icon" />
                <h3 className="tiktok-title">@needahairmakeover on TikTok</h3>
                <p className="tiktok-description">
                  Watch hair transformations, student success stories, and expert tips
                </p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Video Testimonials Carousel */}
      <section className="section-container">
        <div className="content-wrapper">
          <h2 className="section-title">More Success Stories</h2>
          <p className="section-description">
            Watch our students share their training experiences and career transformations
          </p>
          <VideoTestimonialsCarousel />
        </div>
      </section>

      {/* Promo Banner — Hairdressing Is Changing */}
      <section className="section-container" data-testid="testimonials-specialist-banner-section">
        <div className="content-wrapper">
          <div className="testimonials-passion-banner">
            <img
              src="https://customer-assets.emergentagent.com/job_e0838653-edb4-4055-aeea-30513770ad02/artifacts/uy4emldf_WhatsApp%20Image%202026-06-30%20at%2015.44.41%20%288%29.jpeg"
              alt="Hairdressing is changing. Train to become a specialist. Rising hair loss statistics combined with a shortage of trained professionals creates strong demand for specialist skills."
              className="testimonials-passion-banner-image"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Success Highlights */}
      <section className="section-container">
        <div className="content-wrapper">
          <h2 className="section-title">Why Choose Our Training?</h2>
          <div className="highlights-grid">
            <div className="highlight-card">
              <h3 className="highlight-number">4,100+</h3>
              <p className="highlight-text">Successful Graduates</p>
            </div>
            <div className="highlight-card">
              <h3 className="highlight-number">19 Years</h3>
              <p className="highlight-text">Training Experience</p>
            </div>
            <div className="highlight-card">
              <h3 className="highlight-number">100%</h3>
              <p className="highlight-text">CPD Accredited</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;